<script>
import { CountTo } from "vue3-count-to";

export default {
  props: ['stats'],
  components: {
    CountTo,
  },
};
</script>

<style scoped>
.hover-scale {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.hover-scale:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 8px 24px rgba(0,0,0,0.15) !important;
}
</style>

<template>
  <div class="container-fluid px-2">
    <h2 class="my-3 text-center text-md-start">IA Performance Metrics</h2>

    <div class="card border-3 bg-body-tertiary text-body">
      <div class="card-body py-3 px-3">
        <div class="row g-3">
          
          <!-- Candidates Reached -->
          <div class="col-12 col-md-6 col-xl-4">
            <div class="card w-100 h-100 border bg-body-tertiary text-body p-3 hover-scale shadow-sm">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <p class="text-uppercase mb-0 fw-bold fs-6 text-primary">
                  Candidates Reached
                </p>
                <i class="ri-group-line fs-4 text-primary"></i>
              </div>
              <div class="d-flex align-items-center mt-2">
                <div class="avatar-sm bg-soft-primary rounded-circle d-flex align-items-center justify-content-center">
                  <i class="ri-group-fill fs-3 text-primary"></i>
                </div>
                <div class="ms-3">
                  <h2 class="mb-0">
                    <count-to :startVal="0" :endVal="stats.totalCandidates || 0" :duration="2000" />
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <!-- Total Sent -->
          <div class="col-12 col-md-6 col-xl-4">
            <div class="card w-100 h-100 border bg-body-tertiary text-body p-3 hover-scale shadow-sm">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <p class="text-uppercase mb-0 fw-bold fs-6 text-success">
                  Messages Sent
                </p>
                <i class="ri-send-plane-fill fs-4 text-success"></i>
              </div>
              <div class="d-flex align-items-center mt-2">
                <div class="avatar-sm bg-soft-success rounded-circle d-flex align-items-center justify-content-center">
                  <i class="ri-send-plane-2-fill fs-3 text-success"></i>
                </div>
                <div class="ms-3">
                  <h2 class="mb-0">
                    <count-to :startVal="0" :endVal="stats.totalSent || 0" :duration="2000" />
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <!-- Total Received -->
          <div class="col-12 col-md-6 col-xl-4">
            <div class="card w-100 h-100 border bg-body-tertiary text-body p-3 hover-scale shadow-sm">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <p class="text-uppercase mb-0 fw-bold fs-6 text-info">
                  Messages Received
                </p>
                <i class="ri-message-3-line fs-4 text-info"></i>
              </div>
              <div class="d-flex align-items-center mt-2">
                <div class="avatar-sm bg-soft-info rounded-circle d-flex align-items-center justify-content-center">
                  <i class="ri-message-3-fill fs-3 text-info"></i>
                </div>
                <div class="ms-3">
                  <h2 class="mb-0">
                    <count-to :startVal="0" :endVal="stats.totalReceived || 0" :duration="2000" />
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <!-- Candidates Replied -->
          <div class="col-12 col-md-6 col-xl-4">
            <div class="card w-100 h-100 border bg-body-tertiary text-body p-3 hover-scale shadow-sm">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <p class="text-uppercase mb-0 fw-bold fs-6 text-warning">
                  Candidates Replied
                </p>
                <i class="ri-discuss-line fs-4 text-warning"></i>
              </div>
              <div class="d-flex align-items-center mt-2">
                <div class="avatar-sm bg-soft-warning rounded-circle d-flex align-items-center justify-content-center">
                  <i class="ri-discuss-fill fs-3 text-warning"></i>
                </div>
                <div class="ms-3">
                  <h2 class="mb-0">
                    <count-to :startVal="0" :endVal="stats.totalReplied || 0" :duration="2000" />
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <!-- Response Rate -->
          <div class="col-12 col-md-6 col-xl-4">
            <div class="card w-100 h-100 border bg-body-tertiary text-body p-3 hover-scale shadow-sm">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <p class="text-uppercase mb-0 fw-bold fs-6 text-secondary" style="color: #a066ff !important;">
                  Response Rate
                </p>
                <i class="ri-percent-line fs-4 text-secondary" style="color: #a066ff !important;"></i>
              </div>
              <div class="d-flex align-items-center mt-2">
                <div class="avatar-sm bg-soft-secondary rounded-circle d-flex align-items-center justify-content-center" style="background-color: rgba(160, 102, 255, 0.1) !important;">
                  <i class="ri-percent-fill fs-3" style="color: #a066ff !important;"></i>
                </div>
                <div class="ms-3">
                  <h2 class="mb-0">
                    <count-to :startVal="0" :endVal="stats.responseRate || 0.0" :decimals="2" :duration="2000" />%
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <!-- Opt-Outs (Blacklisted) -->
          <div class="col-12 col-md-6 col-xl-4">
            <div class="card w-100 h-100 border bg-body-tertiary text-body p-3 hover-scale shadow-sm">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <p class="text-uppercase mb-0 fw-bold fs-6 text-danger">
                  Opt-Outs (REMOVE)
                </p>
                <i class="ri-user-unfollow-line fs-4 text-danger"></i>
              </div>
              <div class="d-flex align-items-center mt-2">
                <div class="avatar-sm bg-soft-danger rounded-circle d-flex align-items-center justify-content-center">
                  <i class="ri-user-unfollow-fill fs-3 text-danger"></i>
                </div>
                <div class="ms-3">
                  <h2 class="mb-0">
                    <count-to :startVal="0" :endVal="stats.blacklistCount || 0" :duration="2000" />
                  </h2>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
